export const SAVE_VIEW_COMMENTS = 'SAVE_VIEW_COMMENTS'
export const SAVE_VIEW_COMMENTS_FAILED = 'SAVE_VIEW_COMMENTS_FAILED'
